/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MultiDomainMrnComponent } from './multi-domain-mrn/multi-domain-mrn.component';
import { WorkItemAssigneeStatusComponent } from './work-item-assignee-status/work-item-assignee-status.component';
import { TranslateModule } from '@ngx-translate/core';
import { AppPipesModule } from '@app/common/pipes/app-pipes.module';
import { WorkItemStateComponent } from '@app/common/components/work-item-state/work-item-state.component';
import { PopoverModule, ScrollbarModule, SpinnerModule, TooltipModule } from '@wfm/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SelectPanelNewComponent } from '@app/common/components/select-panel-new/select-panel-new.component';
import { FormsModule } from '@angular/forms';

const components = [
  MultiDomainMrnComponent,
  WorkItemAssigneeStatusComponent,
  WorkItemStateComponent,
  SelectPanelNewComponent
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
    AppPipesModule,
    SpinnerModule,
    PopoverModule,
    TooltipModule,
    ScrollingModule,
    ScrollbarModule,
    FormsModule
  ],
  exports: components,
  declarations: components,
  entryComponents: []
})
export class AppComponentsModule {}
